import AbstractHtmlConstructorType
    from "~/cabinet/vue/interface/htmlConstructor/constructorType/AbstractHtmlConstructorType";
import EmailContentDisplay from "~/cabinet/vue/interface/htmlConstructor/constructorType/email/EmailContentDisplay.vue";
import {HTML_BLOCK_TYPE_HEADER, HTML_BLOCK_TYPE_TEXT} from "~/cabinet/vue/interface/htmlConstructor/blocks/Constants";
import {IHtmlConstructorBlock} from "~/cabinet/vue/interface/htmlConstructor/Interface";
import {RawComponent, useRawComponent} from "~/core-ui/ts/useRawComponent";

export default class EmailConstructorType extends AbstractHtmlConstructorType {
    get contentDisplayComponent(): RawComponent {
        return useRawComponent(EmailContentDisplay);
    }

    getDefaultBlockLists(): IHtmlConstructorBlock<any>[] {
        return [
            {
                type: HTML_BLOCK_TYPE_HEADER,
                values: {}
            },
            {
                type: HTML_BLOCK_TYPE_TEXT,
                values: {}
            }
        ];
    }
}